import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useOrganization } from "@/contexts/OrganizationContext";

export interface InsightResult {
  answer: string;
  data: unknown[];
  intent: string;
}

/**
 * Calls relay-ai-hub (type=query_org_data) with a natural language question
 * and returns a narrative answer + the raw data rows used to generate it.
 */
export function useQueryOrgData() {
  const { organizationId } = useOrganization();

  return useMutation({
    mutationFn: async (question: string): Promise<InsightResult> => {
      if (!organizationId) throw new Error("No active organization");
      const res = await supabase.functions.invoke<InsightResult>("relay-ai-hub", {
        body: {
          type: "query_org_data",
          organization_id: organizationId,
          context: { question },
        },
      });
      if (res.error) throw new Error(res.error.message);
      if (!res.data) throw new Error("relay-ai-hub returned no data");
      return res.data;
    },
  });
}
